import * as React from "react";

interface LoadingSpinnerProps {
  darkColor?: boolean;
  cssClasses?: string;
}

/**
 * Renders a spinner. Each div represents a circle in the spinner.
 */
const LoadingSpinner: React.SFC<LoadingSpinnerProps> = (props) => {
  return (
    <div
      className={`lds-roller ${props.cssClasses} ${
        props.darkColor ? "dark" : ""
      }`}
    >
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export default LoadingSpinner;
